// extracted by mini-css-extract-plugin
export default {"wrapper":"announce_wrapper__itJCS","container":"announce_container__m3wYw"};